import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-surface" data-id="element-56" data-mp="1hdupklvgf9bb">
      <div className="max-w-3xl mx-auto" data-id="element-57" data-mp="1cf02v8ud90lx">
        <div className="text-center mb-16" data-id="element-58" data-mp="1cgb9dgf74mgq">
          <h2 className="text-3xl md:text-5xl font-display font-bold uppercase text-primary" data-id="element-59" data-mp="2a1yx7cxl5wgn">
            ❓ Frequently Asked Questions
          </h2>
        </div>
        <div className="space-y-4" data-id="element-60" data-mp="2512qkrlunw7j">
          {faqs.map((faq, index) => <div key={faq.q} className="bg-white border border-primary/15 rounded-xl overflow-hidden shadow-sm shadow-primary/5" data-id="element-61" data-mp="202hp6ouv36hi" data-mpi={index}>
              <button type="button" className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-secondary" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-62" data-mp="op5scxxiro4u">
                <span className="font-bold text-lg text-primary pr-8" data-id="element-63" data-mp="1aq2b3ri9kg2u">{faq.q}</span>
                <ChevronDown className={`text-secondary transition-transform duration-200 ease-out shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-64" data-mp="1fonajopoyvq8" />
              </button>
              <AnimatePresence initial={false} data-id="element-65" data-mp="16oqu2adgh369">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-66" data-mp="s0dvd5mzh682">
                    <div className="px-6 pb-5 text-body border-t border-primary/10 pt-4 space-y-3" data-id="element-67" data-mp="n1sxhcv7eyms">
                      {faq.a.map(paragraph => <p key={paragraph} data-id="element-68" data-mp="2kv52p56tdpdl">{paragraph}</p>)}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}